import {
    Flex, Input, Button, Text, VStack, Link, Divider, InputGroup,
    FormControl, FormErrorMessage, InputLeftElement, Icon,
    useToast
} from '@chakra-ui/react'
import { BsPersonBoundingBox, BsShieldLock, BsBoxArrowInRight } from "react-icons/bs";
import { useUserContext, updateUserData, setLocalUserData } from '../../context/userContext'
import { Link as ReactLink } from 'react-router-dom'
import { useForm, Controller } from "react-hook-form";
import LoginUser, { postLogin } from '../../classes/LoginUser'
// import ModalLoading from '../shared/ModalLoading'
import { InputPassword } from '../shared';
import User from '../../classes/User'
import { useLoadingContext } from '../../context/loadingContext';
import { toastErrDesc, toastVal } from '../../utils/toastUtils';

const LoginForm = ({ ...rest }) => {
    const { control, handleSubmit, formState: { errors } } = useForm()
    const toast = useToast()
    // const { onClose, onOpen, isOpen } = useDisclosure()
    const { dispatchUserData } = useUserContext()
    const { onModalClose, onModalOpen } = useLoadingContext()

    const onSubmit = (data) => {
        // console.log('log in')
        const loginData = new LoginUser(data)
        // console.log(loginData.serialized())
        onModalOpen("กำลังเข้าสู่ระบบ")

        postLogin(loginData.serialized())
            .then(res => {
                const param = {
                    ...res.user,
                    token: res.token,
                    authorized: true,
                }
                const loginUser = new User(param)
                // console.log("-- post ok")
                // console.log(loginUser)
                onModalClose()
                setLocalUserData(loginUser)
                dispatchUserData(updateUserData(loginUser))
            })
            .catch(error => {
                onModalClose()
                // console.log("-- post fail")
                // console.log(error)
                toast(toastVal({
                    title: "การเข้าสู่ระบบ ไม่สำเร็จ",
                    description: toastErrDesc(error),
                    status: "error",
                }))
            })

    }

    return (
        <Flex justify="center" align="center" w={{ sm:"95%",lg:"500px"}} bgColor="blackAlpha.800" borderRadius="lg" {...rest}>
            <Flex p={6} direction="column"  >
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Flex direction="column" w="full" align="center">
                        <Text fontSize="3xl" color="white">ลงชื่อเข้าใช้งานระบบ</Text>
                        <Text fontSize="sm" color="white">กรุณากรอกเลขบัตรประชาชน/ชื่อบัญชีและรหัสผ่าน</Text>
                    </Flex>
                    <VStack spacing={4} mt={8} px={1}>
                        <FormControl isInvalid={errors.username}>
                            <Controller
                                name="username"
                                control={control}
                                rules={{ required: true, maxLength: 13 }}
                                render={({ field }) => (
                                    <InputGroup>
                                        <InputLeftElement
                                            pointerEvents="none"
                                            children={<Icon as={BsPersonBoundingBox} color="gray.300" />}
                                        />
                                        <Input placeholder="เลขบัตรประชาชน/ชื่อบัญชี" type="text" color="white" maxLength={13} {...field} />
                                    </InputGroup>
                                )}
                            />
                            {errors.username?.type === 'required' && <FormErrorMessage>กรุณากรอกเลขบัตรประชาชน/ชื่อบัญชี</FormErrorMessage>}
                            {errors.username?.type === 'maxLength' && <FormErrorMessage>กรอกชื่อบัญชียาวเกินกำหนด</FormErrorMessage>}
                        </FormControl>
                        <FormControl isInvalid={errors.password}>
                            <InputPassword control={control} name="password" color="white" >
                                <InputLeftElement
                                    pointerEvents="none"
                                    children={<Icon as={BsShieldLock} color="gray.300" />}
                                />
                            </InputPassword>
                            {errors.password?.type === 'required' && <FormErrorMessage>กรุณากรอกรหัสผ่าน</FormErrorMessage>}
                            {errors.confirm_password?.type === 'minLength' && <FormErrorMessage>ความยาวรหัสผ่านอย่างน้อย 6 ตัวอักษร</FormErrorMessage>}
                        </FormControl>

                        <Button type="submit" w="full" leftIcon={<BsBoxArrowInRight />} colorScheme="green">เข้าใช้งาน</Button>
                        <Divider />
                        <Flex w="full" justify="center">
                            <Link to="/register" as={ReactLink}>
                                <Text color="white" size="sm">สมัครเข้าใช้งาน</Text>
                            </Link>
                            {/* <Link>
                                <Text color="white" size="sm">ลืมรหัสผ่าน?</Text>
                            </Link> */}
                        </Flex>
                    </VStack>
                </form>
            </Flex>
        </Flex>
    )
}

export default LoginForm